__turbopack_context__.v({
  "className": "dancingscript_1345a87b-module__Ywo07q__className",
  "variable": "dancingscript_1345a87b-module__Ywo07q__variable",
});
